import { render, staticRenderFns } from "./ExtendContainerRow.vue?vue&type=template&id=37874c1a"
import script from "./ExtendContainerRow.vue?vue&type=script&lang=js"
export * from "./ExtendContainerRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37874c1a')) {
      api.createRecord('37874c1a', component.options)
    } else {
      api.reload('37874c1a', component.options)
    }
    module.hot.accept("./ExtendContainerRow.vue?vue&type=template&id=37874c1a", function () {
      api.rerender('37874c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ExtendContainerRow.vue"
export default component.exports